import { useQuery } from "@tanstack/react-query";

import {
  getDealer,
  getDealers,
  getNewDealers,
  getTopDealers,
} from "@Http/dealers";
import { Dealership } from "@Types/dealerships";
import { HttpQuery, PaginatedResult } from "@Types/http";
import { MutationError } from "@Types/index";

const useGetDealers = (query?: HttpQuery) => {
  const queryKey = ["dealership", query];

  const { data, isLoading, isFetching, error } = useQuery<
    PaginatedResult<Dealership[]>,
    MutationError,
    PaginatedResult<Dealership[]>
  >({
    queryKey: queryKey,
    queryFn: getDealers(query),
  });

  return {
    data: data?.docs ?? [],
    totalPages: data?.totalPages ?? 0,
    totalDocs: data?.totalDocs ?? 0,
    isLoading,
    isFetching,
    error,
  };
};
export const useGetTopDealers = (query?: HttpQuery) => {
  const queryKey = ["dealership", query];

  const { data, isLoading, isFetching, error } = useQuery<
    PaginatedResult<Dealership[]>,
    MutationError,
    PaginatedResult<Dealership[]>
  >({
    queryKey: queryKey,
    queryFn: getTopDealers(query),
  });

  return {
    data: data?.docs ?? [],
    totalPages: data?.totalPages ?? 0,
    totalDocs: data?.totalDocs ?? 0,
    isLoading,
    isFetching,
    error,
  };
};

export const useGetDealer = (id: string, enabled = true) => {
  const queryKey = ["dealership", id];

  const { data, isLoading, error } = useQuery<
    Dealership,
    MutationError,
    Dealership
  >({
    queryKey,
    queryFn: getDealer(id),
    enabled,
  });
  return {
    data,
    isLoading,
    error,
  };
};

export const useGetNewDalers = (query?: HttpQuery) => {
  const queryKey = ["new-dealership", query];

  const { data, isLoading, isFetching, error } = useQuery<
    PaginatedResult<Dealership[]>,
    MutationError,
    PaginatedResult<Dealership[]>
  >({
    queryKey: queryKey,
    queryFn: getNewDealers(query),
  });

  return {
    data: data?.docs ?? [],
    totalPages: data?.totalPages ?? 0,
    totalDocs: data?.totalDocs ?? 0,
    isLoading,
    isFetching,
    error,
  };
};

export default useGetDealers;
